<section id="JoinUs" class="section" appFadeIn>
  <div class="container join-us-container">
    <div class="join-us-info" >
      <h2 style="text-align: center;">Dołącz już teraz do Juno Audit™</h2>
      <p class="join-us-slogan" style="text-align: center;">
        Twórz z nami przyszłość audytu i kontroli jakości ze wsparciem asystenta AI.
      </p>
    </div>
    <div class="join-form-box">

      <p>
        <strong>Zostaw swój e-mail</strong> – zaprosimy Cię do wersji beta Juno Audit i powiadomimy, gdy tylko będzie
        dostępna.
      </p>
      <p>
        <strong>Masz konkretne wyzwanie?</strong> Napisz je poniżej – być może już nad tym pracujemy.
      </p>

      <form [formGroup]="contactForm" (ngSubmit)="send()">
        <label>
          Email:
          <input type="email" formControlName="email" required />
          <span class="error" *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span>
            Podaj poprawny adres email.
          </span>
        </label>
        <label>
          Opisz swoje wyzwania(opcjonalnie):
          <textarea formControlName="message" rows="4"></textarea>
        </label>
        <label class="rodo-label">
          <input type="checkbox" formControlName="rodo" required />
          <span class="rodo-text">
           Wyrażam zgodę na wykorzystanie mojego adresu e-mail w zakresie przekazywania informacji o projekcie <strong>Juno Audit </strong> oraz kontaktu w sprawie jego dalszego rozwoju. Więcej informacji znajdziesz w naszej
            <a routerLink="/polityka-prywatnosci">Polityce prywatności</a>
          </span>
        </label>
        <button type="submit" [disabled]="contactForm.invalid || sending">
          Dołącz do nas!
        </button>
        <div *ngIf="sendSuccess" class="success-msg"><span class="app-message__icon app-message__icon--success fa-solid fa-circle-check" aria-hidden="true"></span>
          Dziękujemy za wiadomość!<br />
          Zespół Juno skontaktuje się z Tobą tak szybko, jak to możliwe.
        </div>
        <div *ngIf="sendError" class="error-msg"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> Wystąpił błąd. Spróbuj ponownie.</div>
      </form>
    </div>
  </div>
</section>